import React from 'react';
import { OpenApiRouteResultType } from '../../../../common/src/routes/openApiTypes';
import { translateKeyLang } from '../../../../common/src/translate/translateHelper';
import { IWithReactRouterProps } from '../../mixins/router/withReactRouter';
import { openApiFetchGet } from '../../store/openApiFetch';
import { appContext } from '../appContext';
import {
    Content,
    PanelBody,
    PanelLink,
    Table,
    TableBody,
    TableData,
    TableHead,
    TableHeader,
    TableHeadRow,
    TableRow,
    Topbar,
    TopbarCrumbActive,
    TopbarLeft,
    TopbarRight,
    Tray,
} from '../elements';
import { Component } from '../utils/Component';
import { InvestigationPriorityLabel } from '../utils/InvestigationPriorityLabel';
import { NullableFormattedDate } from '../utils/NullableFormattedDate';

interface ISurveyInvestigationListState extends OpenApiRouteResultType<'/api/surveyInvestigations', 'get'> {
    loading: boolean;
}

export class SurveyInvestigationList extends Component<IWithReactRouterProps, ISurveyInvestigationListState> {
    constructor(props: IWithReactRouterProps) {
        super(props);

        this.state = {
            items: [],
            loading: false,
        };
    }

    public override async componentDidMount() {
        await this.load();
    }

    public override render() {
        return (
            <appContext.Consumer>
                {(state) => (
                    <>
                        <Topbar>
                            <TopbarLeft>
                                <TopbarCrumbActive title={translateKeyLang(state.languageCode, 'survey.investigationPriority')} icon="fa-tag" />
                            </TopbarLeft>
                            <TopbarRight>
                                <PanelLink
                                    href="/api/surveyInvestigations/excel"
                                    text="Excel export"
                                    isDownload={true}
                                    icon="fa fa-download"
                                    small={true}
                                />
                            </TopbarRight>
                        </Topbar>

                        <Content>
                            <Tray>
                                <PanelBody noPadding>
                                    <Table hover>
                                        <TableHead>
                                            <TableHeadRow light>
                                                <TableHeader>{translateKeyLang(state.languageCode, 'common.name')}</TableHeader>
                                                <TableHeader>{translateKeyLang(state.languageCode, 'common.date')}</TableHeader>
                                                <TableHeader>{translateKeyLang(state.languageCode, 'common.unit')}</TableHeader>
                                                <TableHeader>{translateKeyLang(state.languageCode, 'common.description')}</TableHeader>
                                                <TableHeader>&nbsp;</TableHeader>
                                            </TableHeadRow>
                                        </TableHead>
                                        <TableBody>
                                            {this.state.items.map((item, i) => (
                                                <TableRow key={i} onClick={() => this.rowClicked(item.surveyId)}>
                                                    <TableData> {item.name} </TableData>
                                                    <TableData nowrap={true}>
                                                        {' '}
                                                        <NullableFormattedDate value={item.surveryedOn} />{' '}
                                                    </TableData>
                                                    <TableData> {item.location} </TableData>
                                                    <TableData> {item.description} </TableData>
                                                    <TableData alignRight={true}>
                                                        {' '}
                                                        <InvestigationPriorityLabel value={item.priority} />{' '}
                                                    </TableData>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </PanelBody>
                            </Tray>
                        </Content>
                    </>
                )}
            </appContext.Consumer>
        );
    }

    private rowClicked(surveyId: string) {
        const url = `/surveys/${surveyId}`;
        this.props.navigate(url);
    }

    private async load() {
        await this.setState({ loading: true });
        const result = await openApiFetchGet('/api/surveyInvestigations', {});
        await this.setState({ items: result.items, loading: false });
    }
}
